import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { EmbeddedPriorityViewForm } from "../pages/EmbeddedPriorityViewForm";
import { JoinQueueLanding } from "../pages/JoinQueueLanding";
import { LandingHome } from "../pages/LandingHome";
import { ManageEmailPreferences } from "../pages/ManageEmailPreferences";
import { QueueLanding } from "../pages/QueueLanding";
import { ReferralLanding } from "../pages/ReferralLanding";
import { TestClientEmbed } from "../pages/TestClientEmbed";
import { UnsubscribeEmail } from "../pages/UnsubscribeEmail";
import { UpoadFilesPublicPage } from "../pages/UpoadFilesPublicPage";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LandingHome />} />
                <Route path="/queue" element={<QueueLanding />} />
                <Route path="/join-queue" element={<JoinQueueLanding />} />
                <Route path="/queue-referral" element={<ReferralLanding />} />
                <Route
                    path="/email-preferences/unsubscribe/:encodedUnsubscribeKeys"
                    element={<UnsubscribeEmail />}
                />
                <Route
                    path="/email-preferences/manage/:encodedUnsubscribeKeys"
                    element={<ManageEmailPreferences />}
                />
                <Route
                    path="/organizations/:organizationId/embedded-priority-view-form"
                    element={<EmbeddedPriorityViewForm />}
                />
                <Route
                    path="/test-client-embed"
                    element={<TestClientEmbed />}
                />
                <Route
                    path="/upload-files"
                    element={<UpoadFilesPublicPage />}
                />
            </Routes>
        </Router>
    );
}

export default App;
